import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ContactMethod, ResendConfirmationCodeInput, ValidationError } from '@queries/generated';
import { CurrentUserService } from '@services/current-user.service';
import { FormActionsComponent } from '@shared/components/form-actions/form-actions.component';
import { ContactPipe } from '@shared/pipes/contact.pipe';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

type ContactMethodWithCode = ContactMethod & {
  code?: string;
};

@Component({
  selector: 'vnm-confirm-contact',
  templateUrl: './confirm-contact.component.html',
  styleUrls: ['./confirm-contact.component.scss'],
  providers: [ContactPipe]
})
export class ConfirmContactComponent implements OnInit {
  @ViewChild(FormActionsComponent, { static: true }) formActions: FormActionsComponent;
  method: ContactMethodWithCode;
  errors: ValidationError[];

  constructor(
    public dialog: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private userService: CurrentUserService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private contactPipe: ContactPipe
  ) {}

  ngOnInit() {
    this.method = this.config.data.method;
  }

  submit() {
    const input = {
      contactMethodId: this.method.gid,
      confirmationCode: this.method.code
    };

    this.userService.confirmContactMethod(input).subscribe(
      (method) => {
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('confirm-contact.contact-confirmed', {
            value: this.contactPipe.transform(method.value)
          })
        });
        this.dialog.close();
      },
      (errors) => {
        this.errors = errors;
        this.formActions.reset();
      },
      () => this.userService.refresh()
    );
  }

  resendConfirmation() {
    const input: ResendConfirmationCodeInput = {
      id: this.method.id
    };
    this.userService.resendConfirmationCode(input).subscribe((sent) => {
      const msg = sent ? 'confirm-contact.code-resent' : 'confirm-contact.code-not-sent';

      this.messageService.add({
        severity: sent ? 'success' : 'warning',
        summary: this.translateService.instant(msg, { value: this.contactPipe.transform(this.method.value) })
      });
    });
  }
}
